import { saveCommercialSurvey } from '../../api/commercial_analytics';
import { EAnswers, EPaymentType, EUserType, EPageType } from '../../repositories/commercial-analytics/v1/save-survey';
import { IThunkActionCreator } from '../index';

export interface ISurvey {
  answers: EAnswers[];
  paymentType?: EPaymentType;
  userType?: EUserType;
  phone?: string;
  email?: string;
  comment?: string;
}

export type TStatusFetch = 'none' | 'isLoad' | 'error' | 'ok';

export interface ICommercialSurveyWidgetModalOpened {
  type: 'ICommercialSurveyWidgetModalOpened';
}

export function openCommercialWidgetModal(): ICommercialSurveyWidgetModalOpened {
  return {
    type: 'ICommercialSurveyWidgetModalOpened',
  };
}

export interface ICommercialSurveyWidgetModalClosed {
  type: 'ICommercialSurveyWidgetModalClosed';
}

export function closeCommercialWidgetModal(): ICommercialSurveyWidgetModalClosed {
  return {
    type: 'ICommercialSurveyWidgetModalClosed',
  };
}

export interface ICommercialSurveyRequestStart {
  type: 'ICommercialSurveyRequestStart';
  payload: {
    statusFetch: 'isLoad';
  };
}

export function commercialSurveyRequestStart(): ICommercialSurveyRequestStart {
  return {
    type: 'ICommercialSurveyRequestStart',
    payload: {
      statusFetch: 'isLoad',
    },
  };
}

interface ICommercialSurveyRequestSuccess {
  type: 'ICommercialSurveyRequestSuccess';
  payload: {
    statusFetch: 'ok';
  };
}

export function commercialSurveyRequestSuccess(): ICommercialSurveyRequestSuccess {
  return {
    type: 'ICommercialSurveyRequestSuccess',
    payload: {
      statusFetch: 'ok',
    },
  };
}

interface ICommercialSurveyRequestError {
  type: 'ICommercialSurveyRequestError';
  payload: {
    statusFetch: 'error';
  };
}

export function commercialSurveyRequestError(): ICommercialSurveyRequestError {
  return {
    type: 'ICommercialSurveyRequestError',
    payload: {
      statusFetch: 'error',
    },
  };
}

export function sendCommercialSurvey(survey: ISurvey): IThunkActionCreator {
  return (dispatch, getState, context) => {
    const {
      pageData: { offerId },
    } = getState();

    dispatch(commercialSurveyRequestStart());

    const answer = {
      ...survey,
      offerId,
      pageType: EPageType.Card,
    };

    return saveCommercialSurvey(context.httpApi, answer)
      .then(() => {
        dispatch(commercialSurveyRequestSuccess());
      })
      .catch(() => {
        dispatch(commercialSurveyRequestError());
      });
  };
}

export function closeAndSaveCommercialSurvey(survey: ISurvey | null): IThunkActionCreator {
  return dispatch => {
    if (survey) {
      dispatch(sendCommercialSurvey(survey));
    }

    dispatch(closeCommercialWidgetModal());
  };
}

export interface ICommercialSurveyWidgetModalState {
  isOpen: boolean;
  statusFetch: TStatusFetch;
}

export const defaultState: ICommercialSurveyWidgetModalState = {
  isOpen: false,
  statusFetch: 'none',
};

export type ICommercialSurveyAction =
  | ICommercialSurveyWidgetModalOpened
  | ICommercialSurveyWidgetModalClosed
  | ICommercialSurveyRequestStart
  | ICommercialSurveyRequestSuccess
  | ICommercialSurveyRequestError;

export function commercialSurveyWidgetModal(
  state: ICommercialSurveyWidgetModalState = defaultState,
  action: ICommercialSurveyAction,
): ICommercialSurveyWidgetModalState {
  switch (action.type) {
    case 'ICommercialSurveyWidgetModalOpened':
      return {
        ...state,
        isOpen: true,
      };

    case 'ICommercialSurveyWidgetModalClosed':
      return {
        ...state,
        isOpen: false,
      };

    case 'ICommercialSurveyRequestStart':
    case 'ICommercialSurveyRequestSuccess':
    case 'ICommercialSurveyRequestError':
      return {
        ...state,
        statusFetch: action.payload.statusFetch,
      };

    default:
      return state;
  }
}
